// NOTE: The order of the imports is important.

// @ts-expect-error - This alias is resolved by Rspack
import * as OriginalReact from "__real_react__";

import { useSyncExternalStore as useSyncExternalStoreActual } from "use-sync-external-store/shim";

// @ts-expect-error
export * from "__real_react__";
export default OriginalReact;

export const useInsertionEffect: typeof OriginalReact.useLayoutEffect = OriginalReact.useLayoutEffect;
export const useSyncExternalStore: typeof useSyncExternalStoreActual = useSyncExternalStoreActual;

if (OriginalReact) {
  if (typeof (OriginalReact as any).useInsertionEffect === "undefined" && OriginalReact.useLayoutEffect) {
    (OriginalReact as any).useInsertionEffect = OriginalReact.useLayoutEffect;
  }
  if (typeof (OriginalReact as any).useSyncExternalStore === "undefined") {
    (OriginalReact as any).useSyncExternalStore = useSyncExternalStoreActual;
  }
}
